import Vue from 'vue'
import Router from 'vue-router'
// import DashboardLayout from '@/layout/DashboardLayout'
// import AuthLayout from '@/layout/AuthLayout'
import SESLayout from '@/layout/SESLayout'
import NoSidebarLayout from '@/layout/NoSidebarLayout'
import staticTableRoutes from './components/StaticTable/data/static-table-routes.json'
Vue.use(Router)
// Vue.http.options.root = 'http://ses.dev.local';

staticTableRoutes[0].component = () => import('./views/Admin/StaticTables.vue')

for(let i = 1; i < staticTableRoutes.length; i++) {
  staticTableRoutes[i].component = () => import('./views/Admin/StaticTable.vue')
}

var router = new Router({
  linkExactActiveClass: 'active',
  base: '/project/',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'login',
      component: SESLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Pages/Main.vue')
        },
        {
          path: '/icons',
          name: 'icons',
          component: () => import(/* webpackChunkName: "demo" */ './views/Icons.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue')
        },
        {
          path: '/maps',
          name: 'maps',
          component: () => import(/* webpackChunkName: "demo" */ './views/Maps.vue')
        },
        {
          path: '/tables',
          name: 'tables',
          component: () => import(/* webpackChunkName: "demo" */ './views/Tables.vue')
        },
        {
          path: '/projects',
          name: 'My Projects',
          props: { default: true, subproject: false },
          component: () => import('./views/Projects.vue')
        },
        {
          path: '/planning',
          name: 'Planning',
          component: () => import('./views/Planning.vue')
        },
        {
          path: '/drawings',
          name: 'Copied Drawings',
          component: () => import('./views/Drawing/DuplicateDrawing.vue')
        },
        {
          path: '/drawings/duplicate/:id',
          name: 'Copy Drawing',
          component: () => import('./views/Drawing/Duplicate.vue')
        },
        {
          path: '/drawings/edit/:editId',
          name: 'Edit Duplicate',
          component: () => import('./views/Drawing/Duplicate.vue')
        },
        {
          path: '/subprojects',
          name: 'Sub Projects',
          props: { default: true, subproject: true },
          component: () => import('./views/Projects.vue')
        },
        {
          path: '/tickets',
          name: 'My Tickets',
          component: () => import('./views/Pages/Tickets.vue')
        },
        {
          path: '/modernization',
          name: 'Modernization',
          component: () => import('./views/Pages/Modernization.vue')
        },
        {
          path: '/construction',
          name: 'Construction',
          component: () => import('./views/Pages/Construction.vue')
        },
        {
          path: '/sform/construction',
          name: 'Construction',
          props: { default: true, ftype: 'initial', rtype: 'construction' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/sform/construction/final',
          name: 'Construction',
          props: { default: true, ftype: 'final', rtype: 'construction' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/parts-tools',
          name: 'Parts and Tools',
          component: () => import('./views/Pages/PartsTools.vue')
        },
        {
          path: '/support',
          name: 'Support',
          component: () => import('./views/Pages/Support.vue')
        },
        {
          path: '/technical-documents',
          name: 'Technical Documents',
          component: () => import('./views/Pages/TechnicalDocuments.vue')
        },
        {
          path: '/form/initial',
          name: 'Modernization',
          props: { default: true, ftype: 'initial', rtype: 'modernization' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/form/final',
          name: 'Modernization',
          props: { default: true, ftype: 'final', rtype: 'modernization' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/duplicate/:id',
          name: 'Modernization',
          props: { default: true, ftype: 'duplicate', rtype: 'modernization' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/construction/duplicate/:id',
          name: 'Construction',
          props: { default: true, ftype: 'duplicate', rtype: 'construction' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/construction/final/:id',
          name: 'Construction',
          props: { default: true, ftype: 'final', rtype: 'construction' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/final/:id',
          name: 'Modernization',
          props: { default: true, ftype: 'final', rtype: 'modernization' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/initial/:id',
          name: 'Modernization',
          props: { default: true, ftype: 'initial', rtype: 'modernization' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/construction/initial/:id',
          name: 'Construction',
          props: { default: true, ftype: 'initial', rtype: 'construction' },
          component: () => import('./views/Pages/FormCon.vue')
        },
        {
          path: '/brakeadjustment',
          name: 'Brake Adjustments',
          component: () => import('./views/Pages/BrakeAdjustment.vue')
        },
        {
          path: '/training-videos',
          redirect: '/service-videos',
        },
        {
          path: '/service-videos',
          name: 'Service Videos',
          component: () => import('./views/Pages/TrainingVideos.vue')
        },
        {
          path: '/hyperion-price-lists',
          name: 'Hyperion Price Lists',
          component: () => import('./views/Pages/HyperionPriceLists.vue')
        },
        {
          path: '/troubleshooting',
          name: 'Troubleshooting Guides',
          component: () => import('./views/Pages/Troubleshooting.vue')
        },
        {
          path: '/spare-parts',
          name: 'Spare Parts',
          component: () => import('./views/Shops/SpareParts.vue')
        },
        {
          path: '/components',
          name: 'Elevator Components',
          component: () => import('./views/Shops/ElevatorComponents.vue')
        },
        {
          path: '/cart',
          name: 'Cart',
          component: () => import('./views/Shops/Cart.vue')
        },
        {
          path: '/dash-support',
          name: 'Dashboard Support',
          component: () => import('./views/Pages/DashboardSupport.vue')
        },
        {
          path: '/request-support',
          name: 'Request Support',
          component: () => import('./views/Pages/RequestSupport.vue')
        },
        {
          path: '/warranty-claim/:surveyId?',
          name: 'Warranty Claim',
          component: () => import('./views/Pages/WarrantyClaim.vue')
        },
        /* Administrative */
        {
          path: '/users',
          name: 'Manage Users',
          component: () => import('./views/Admin/Users.vue')
        },
        {
          path: '/roles',
          name: 'Manage Roles',
          component: () => import('./views/Admin/Roles.vue')
        },
        {
          path: '/role/:id',
          name: 'Edit Role',
          component: () => import('./views/Admin/RoleForm.vue')
        },
        {
          path: '/rolex/:id',
          name: 'Edit Role',
          component: () => import('./views/Admin/RoleFormV2.vue')
        },
        {
          path: '/user/:id',
          name: 'Edit User',
          component: () => import('./views/Admin/UserForm.vue')
        },
        {
          path: '/registrations',
          name: 'Manage Registrations',
          component: () => import('./views/Admin/Registrations.vue')
        },
        {
          path: '/settings',
          name: 'Settings',
          component: () => import('./views/Admin/Settings.vue')
        },
        {
          path: '/follow-up-emails',
          name: 'Follow Up Emails',
          component: () => import('./views/Admin/FollowUpEmails.vue')
        },
        {
          path: '/manage-spare-parts',
          name: 'Manage Spare Parts',
          component: () => import('./views/Admin/SpareParts.vue')
        },
        {
          path: '/sap/:survey',
          name: 'SAP Survey Info',
          component: () => import('./views/Admin/SurveySAP.vue'),
          props: true
        },
        {
          path: '/survey-summaries',
          name: 'Survey Summaries',
          component: () => import('./views/Admin/SurveySummaries.vue')
        },
        {
          path: '/engineering-reports/:quoteNumber',
          name: 'Engineering Reports',
          component: () => import('./views/Admin/EngineeringReports.vue'),
          props: true
        },
        {
          path: '/engineering-reports/:quoteNumber/:slug',
          name: 'Engineering Report',
          component: () => import('./views/Admin/EngineeringReport.vue'),
          props: true
        },
        {
          path: '/constants',
          name: 'Constants',
          component: () => import('./views/Admin/Constants.vue'),
        },
        {
          path: '/inquiries',
          name: 'Inquiries',
          component: () => import('./views/Admin/Inquiries.vue')
        },
        {
          path: '/document-lookup/:serial',
          name: 'Document Lookup',
          component: () => import('./views/Pages/DocumentLookup.vue')
        },
        {
          path: '/document-lookup',
          name: 'Document Lookup',
          component: () => import('./views/Pages/DocumentLookup.vue')
        },
        {
          path: '/careers',
          name: 'Manage Careers',
          component: () => import('./views/Admin/Career/Careers.vue')
        },
        {
          path: '/careers/:id',
          name: 'Manage Career',
          component: () => import('./views/Admin/Career/components/ManageCareer.vue')
        },
        {
          path: '/item-leads',
          name: 'Manage Item Lead Time',
          component: () => import('./views/Admin/ItemLeadTime/ItemLeadTimeList.vue')
        }
      ].concat(staticTableRoutes)
    },
    {
      path: '/',
      redirect: 'login',
      component: SESLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Login.vue')
        },
        {
          path: '/reset',
          name: 'Reset Password',
          component: () => import('./views/Pages/ResetPasswordInline.vue')
        },
        {
          path: '/logout',
          name: 'logout',
          component: () => import(/* webpackChunkName: "demo" */ './views/Logout.vue')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/Register.vue')
        },
        {
          path: '/list',
          name: 'My Projects',
          component: () => import('./views/Projects.vue')
        },
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: NoSidebarLayout,
      children: [
        {
          path: '/request-support/success',
          name: 'Request Support',
          component: () => import('./views/Pages/Success/RequestSupport.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: NoSidebarLayout,
      children: [
        {
          path: '/questionnaire',
          name: 'Questionnaire',
          component: () => import('./views/Pages/Questionnaire.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: NoSidebarLayout,
      children: [
        {
          path: '/reset-password/:username/:token',
          name: 'Reset Password',
          component: () => import('./views/Pages/ResetPassword.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: NoSidebarLayout,
      children: [
        {
          path: '/forgot-password',
          name: 'Forgot Password',
          component: () => import('./views/Pages/ForgotPassword.vue')
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');
  const isIE = (msie > 0 || trident > 0);

  if(isIE) window.location.href = '/not-supported';
  else next();
});

export default router;
